module.exports = __webpack_public_path__ + "img/established.86451bbd.svg";